import { MDBBtn, MDBChip, MDBIcon } from "mdb-react-ui-kit";
import React, { useEffect, useState } from "react";
import TelephoneNumbers from "../components/TelephoneNumbers";
import { useNavigate } from "react-router";
import { getMisc, updateFaxGroup } from "../apiclients/streamsapi_bridge";
import { formattedNumber } from "./popups/phonenumbers/AddRemoveNumbers";

function FaxGroupAttribute({
  register,
  errors,
  watch,
  dids,
  setError,
  setSuccessMessage,
  code,
  setValue,
  reset,
  getValues,
  setIsloading,
  clearErrors,
}) {
  const [faxnumbers, setfaxnumbers] = useState([]);
  const [dbPhoneNumbers, setdbPhoneNumbers] = useState([]);
  const [freePhoneFlag, setfreePhoneFlag] = useState(true);
  const [sourceNumber, setSourceNumber] = useState([]);
  const navigate = useNavigate();
  const [updateNumbersExecuted, setUpdateNumbersExecuted] = useState(false);
  const [deleteNumberFlag, setDeleteNumberFlag] = useState(false);
  const [updatePHNum, setUpdatePHNum] = useState([]);
  useEffect(() => {
    if (dids?.length > 0) {
      setfaxnumbers(dids);
      setdbPhoneNumbers(dids);
    }
  }, [dids]);
  useEffect(() => {
    if (freePhoneFlag) {
      getFreePhoneNumbers();
      setfreePhoneFlag(false);
    }
  }, [freePhoneFlag]);

  async function getFreePhoneNumbers() {
    let updates = {};
    console.log(sessionStorage.getItem("admin_session"));
    updates = {
      misc: ["free_dids"],
    };

    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      updates
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const basicInfo = await response.json();
    if (!basicInfo) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    console.log("response data is :::::::::: " + basicInfo);
    setSourceNumber(basicInfo.misc.free_dids);
  }

  useEffect(() => {
    if (updatePHNum.length > 0 && updateNumbersExecuted) {
      addPhoneNumbers("adddids");
      setUpdateNumbersExecuted(false);
    }
  }, [updatePHNum, updateNumbersExecuted]);

  useEffect(() => {
    if (updatePHNum.length > 0 && deleteNumberFlag) {
      addPhoneNumbers("removedids");
      setDeleteNumberFlag(false);
    }
  }, [updatePHNum, deleteNumberFlag]);

  async function addPhoneNumbers(fieldName) {
    setIsloading(true);
    let update = {
      reqid: 117,
      siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      code: code,
      [fieldName]: updatePHNum,
    };

    if (fieldName === "adddids" && faxnumbers.length === 0) {
      update.primary_did = updatePHNum[0];
    }
    console.log(JSON.stringify(update));
    console.log(JSON.stringify(update));
    let saverep = await updateFaxGroup(update);
    console.log(saverep);
    let saverepeMsg = await saverep.json();
    if (saverepeMsg.status && saverepeMsg.status == "success") {
      //debugger;
      if (fieldName === "adddids") {
        if (faxnumbers.length === 0) {
          reset((prev) => ({ ...prev, primary_did: updatePHNum[0] }), {
            keepDirtyValues: true,
          });
        }
        setfaxnumbers((prev) => [...prev, ...updatePHNum]);
        setdbPhoneNumbers((prev) => [...prev, ...updatePHNum]);
        setSuccessMessage(`Telephone Number ${updatePHNum} added successfully.`);
      } else {
        const updateAddPHNum = faxnumbers.filter(
          (num) => !updatePHNum.includes(num)
        );
        setfaxnumbers(updateAddPHNum);
        setdbPhoneNumbers(updateAddPHNum);
        setSuccessMessage(
          `Telephone Number ${updatePHNum} removed successfully.`
        );
      }
      setfreePhoneFlag(true);
    } else {
      if (fieldName === "removedids") {
        const modifynum = faxnumbers.filter(
          (num) => !updatePHNum.includes(num)
        );
        setfaxnumbers([...dbPhoneNumbers]);
        // setdbPhoneNumbers([...modifynum, ...updatePHNum]);
      }
       if (saverepeMsg.message?.errors) {
          saverepeMsg.message.errors.forEach((err) => {
            setError(err.param_name, {
              type: "server",
              message: err.message,
            });
            const fieldElement = document.querySelector(
              `input[name="${err.param_name}"]`
            );
            if (fieldElement) {
              fieldElement.focus();
              fieldElement.scrollIntoView({ behavior: "smooth" });
            }
          });
        }
    }
    setIsloading(false);
  }
  return (
    <>
      <div className="general-settings">Phone Numbers</div>
      <TelephoneNumbers
        savedPhoneNumbers={faxnumbers}
        setSavedPhoneNumbers={setfaxnumbers}
        setSuccessMessage={setSuccessMessage}
        uniqueid={code}
        setUpdatePHNum={setUpdatePHNum}
        setUpdateNumbersExecuted={setUpdateNumbersExecuted}
        sourceNumber={sourceNumber}
        setDeleteNumberFlag={setDeleteNumberFlag}
        dbPhoneNumbers={dbPhoneNumbers}
        faxerrorkey = "adddids"
        clearErrors = {clearErrors}
        
      />
      {errors?.adddids && (
        <p className="text-danger">{errors?.adddids.message}</p>
      )}
      <div class="add-numbermain">
        <div class="tel-numbers">Primary Fax Number</div>
        <div class="d-flex w-30">
          <div class="phoneselect w-100">
            <select
              name=""
              id=""
              className="form-select form-control"
              value={watch("primary_did")}
              onChange={(e) =>
                setValue("primary_did", e.target.value, {
                  shouldDirty: true,
                })
              }
              // {...register("attributes.primaryfaxdid")}
            >
              {faxnumbers?.length > 0 &&
                faxnumbers.map((number) => (
                  <option value={number}>{formattedNumber(number)}</option>
                ))}
            </select>
          </div>
        </div>
      </div>
    </>
  );
}

export default FaxGroupAttribute;
